import axiosInstance from '@/utils/api.js'

var state = {
  periodicServiceLink: []
}

var getters = {
  PERIODIC_SERVICE_LINK: (state) => {
    return state.periodicServiceLink
  }
}

var mutations = {
  SET_PERIODIC_SERVICE_LINK: (state, payload) => {
    state.periodicServiceLink = payload || []
  }
}

var actions = {
  GET_PERIODIC_SERVICE_LINK: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks/periodic?slink_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_PERIODIC_SERVICE_LINK', result.data)
    }
  },
  CREATE_PERIODIC_SERVICE_LINK: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/periodic', payload)
  },
  UPDATE_PERIODIC_SERVICE_LINK: (context, payload) => {
    return axiosInstance.put('/users/servicelinks/periodic', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/servicesLinkPeriodic.js